import React,{useState,useEffect} from 'react';
import QRCode from "react-qr-code";
import {Skeleton, Button, Divider, Table, Card, Modal} from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {useAxios} from "../../hooks/hooks";
import {useParams, useLocation} from "react-router-dom";
import {downloadQRCodePoster, QRCodePosterDocument} from "../components/QRCodePoster";
import config from "../../business/config.json";

function QRPosterPage(props){
	const {id} = useParams();
	const axios = useAxios();

	const [project,setProject] = useState(null);
	const [logins,setLogins] = useState(null);
	const [loaded,setLoaded] = useState(false);

	const getProject = async (id_project) => {
		try{
			const response = await axios.current.get("/project-view/"+id_project);
			return response.data[0];
		}catch(e){
			console.error(e);
			return null;
		}
	}

	const getLogins = async () => {
		try{
			const response = await axios.current.get(`/project/${id}/contractor-access/login-records`);
			return response.data;
		}catch(e){
			console.error(e);
		}
	}

	const createUser = async () => {
		try{
			const response = await axios.current.get(`/project/${id}/contractor-access/register`);
			getLogins().then(values => {
				setLogins(values);
			})
			if (response.data && response.data.password) {
				Modal.success({
					title: 'User Created',
					content: (
						<div>
							<p>The contractor user has been created successfully.</p>
							<p><strong>Email:</strong> {id}@ade.group</p>
							<p><strong>Password:</strong> {response.data.password}</p>
							<p>Please record this password as it will not be shown again.</p>
						</div>
					),
				});
			}
			return response.data;
		}catch(e){
			console.error(e);
			Modal.error({
				title: 'Could not create user',
				content: (e.response && e.response.data && e.response.data.error) || 'Unexpected error, please try again.',
			});
		}
	}

	const resetUser = async () => {
		try{
			const response = await axios.current.get(`/project/${id}/contractor-access/reset`);
			getLogins().then(values => {
				setLogins(values);
			})
			if (response.data && response.data.password) {
				Modal.success({
					title: 'Password Reset',
					content: (
						<div>
							<p>The contractor user password has been reset successfully.</p>
							<p><strong>Email:</strong> {id}@ade.group</p>
							<p><strong>New Password:</strong> {response.data.password}</p>
							<p>Please record this password as it will not be shown again.</p>
						</div>
					),
				});
			}
			return response.data;
		}catch(e){
			console.error(e);
			Modal.error({
				title: 'Could not reset password',
				content: (e.response && e.response.data && e.response.data.error) || 'Unexpected error, please try again.',
			});
		}
	}

	useEffect(()=>{
		if (loaded) return;
		setLoaded(false);
		Promise.all([getProject(id)]).then( values => {
			setLoaded(true);
			if(undefined === values[0] || values[0] === null){
				return;
			}
			setProject(values[0]);
		});

		getLogins().then(values => {
			setLogins(values);
		})

	},[loaded]);

	const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
		},
		{
			title: 'Phone',
			dataIndex: 'phone',
			key: 'phone',
		},
		{
			title: 'Time',
			dataIndex: 'time',
			key: 'time',
		}
	];

	if(loaded === false){
		return (
			<>
			<PageHeader
				title="QR Poster"
				style={{padding:0,paddingBottom:16}}
			/>
				<Skeleton />
			</>
		);
	}

	if(project === null){
		return (
			<>
			<PageHeader
				title="QR Poster"
				style={{padding:0,paddingBottom:16}}
			/>
				<h1>Project not found.</h1>
			</>
		);
	}

	return (
		<>
			<PageHeader
				title="QR Poster"
				style={{padding:0,paddingBottom:16}}
				extra={[
					<Button
						key="download"
						type="primary"
						onClick={() => downloadQRCodePoster(project)}
						style={{marginRight: 8}}
					>
						<FontAwesomeIcon icon="download" className="fa-fw"/>&nbsp;
						Download PDF
					</Button>,
					<Button
						key="download-grayscale"
						type="default"
						onClick={() => downloadQRCodePoster(project, true)}
						style={{marginRight: 8}}
					>
						<FontAwesomeIcon icon="print" className="fa-fw"/>&nbsp;
						Download PDF (Grayscale)
					</Button>
				]}
			/>
			<div style={{
				backgroundColor: "#1890ff",
				border: "5px solid #000",
				padding: "20px",
				color: "#fff",
				maxWidth: "800px",
				margin: "0 auto"
			}}>
				<h1 style={{ color: "#fff", textAlign: "left", borderBottom: "1px solid #fff", paddingBottom: "10px" }}>HAZMAT Building Report</h1>

				<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "10px 0" }}>
					<span style={{ fontWeight: "bold" }}>Place ({id})</span>
					<span>{project.place_project}</span>
				</div>
				<Divider style={{ margin: "0", backgroundColor: "#fff" }} />

				<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "10px 0" }}>
					<span style={{ fontWeight: "bold" }}>Address</span>
					<div style={{ textAlign: "right" }}>
						{project.street_project}<br/>
						{project.city_project}<br/>
						{project.name_region} {project.postcode_project}
					</div>
				</div>
				<Divider style={{ margin: "0", backgroundColor: "#fff" }} />

				<div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px 0" }}>
					<h2 style={{ color: "#fff", alignSelf: "flex-start" }}>Report</h2>
					<div style={{ backgroundColor: "#fff", padding: "10px", borderRadius: "8px" }}>
						<QRCode
							size={256}
							style={{ height: "auto", maxWidth: "100%", width: "100%" }}
							value={`${config.app_domain}/dashboard/docs/contractor-download/${project.ID || project.id_project || id}`}
							viewBox={`0 0 512 512`}
						/>
					</div>
				</div>
				<Divider style={{ margin: "0", backgroundColor: "#fff" }} />

				<div style={{ textAlign: "left", padding: "20px 0" }}>
					<h2 style={{ color: "#fff" }}>Inspected By</h2>
					<div style={{ display: "flex", alignItems: "center" }}>
						<img
							src={require('../../business/assets/img/ade-logo-square.png')}
							alt="ADE Logo"
							style={{ width: "100px", marginRight: "20px" }}
						/>
						<div style={{ flex: 1 }}>
							<h3 style={{ color: "#fff", margin: 0 }}>ADE Consulting Group</h3>
							<a href="https://ade.group" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "underline" }}>
								https://ade.group
							</a>
						</div>
					</div>
				</div>
			</div>
			<div style={{ padding: "20px 0" }}>
				{logins && logins.length > 0 ? (
					<Card title="Contractor Access Logins" extra={
						<Button onClick={resetUser} type="danger">
							<FontAwesomeIcon icon="sync" className="fa-fw" />&nbsp;
							Reset User
						</Button>
					}>
						<Table
							dataSource={logins}
							columns={columns}
							rowKey={(record) => record.keycloak_user_id + record.name}
						/>
					</Card>
				) : (
					<Card title="Contractor Access">
						<Button onClick={createUser} type="primary">
							<FontAwesomeIcon icon="user-plus" className="fa-fw" />&nbsp;
							Create User
						</Button>
					</Card>
				)}
			</div>
		</>
	);
}

export default QRPosterPage;
